export default {
  Espoo: 49,
  Forssa: 61,
  Helsinki: 91,
  Hyvinkää: 106,
  Hämeenlinna: 109,
  Iisalmi: 140,
  Imatra: 153,
  Joensuu: 167,
  Jyväskylä: 179,
  Jämsä: 182,
  Järvenpää: 186,
  Kaarina: 202,
  Kajaani: 205,
  Kalajoki: 208,
  Kemi: 240,
  Kitee: 260,
  Kokkola: 272,
  Kotka: 285,
  Kouvola: 286,
  Kuopio: 297,
  Lahti: 398,
  Lappeenranta: 405,
  Lohja: 444,
  Loimaa: 430,
  Mikkeli: 491,
  Nokia: 536,
  Oulainen: 563,
  Oulu: 564,
  Pieksämäki: 593,
  Pori: 609,
  Porvoo: 638,
  Raahe: 678,
  Rauma: 684,
  Riihimäki: 694,
  Rovaniemi: 698,
  Salo: 734,
  Sastamala: 790,
  Savonlinna: 740,
  Seinäjoki: 743,
  Tampere: 837,
  Tornio: 851,
  Turku: 853,
  Uusikaupunki: 895,
  Vaasa: 905,
  Vantaa: 92,
  Varkaus: 915,
  Ylivieska: 977,
  Äänekoski: 992,
};
